<template>
  <soha-page-loading v-if="loading" class="mt-25" />
  <div v-else class="col col-lg-12 bg-white py-2">
    <div class="mb-1">
      <div class="d-flex justify-content-between soha-title-of-filter h-40px">
        <div class="row">
          <img class="mx-2" src="/media/svg/soha/icons/filter.svg" />
          <h3 class="m-auto">
            {{ $t(`${I18nPrefix}TITLE`) }}
          </h3>
        </div>
        <soha-button
          v-if="showDeleteFilter"
          variant="danger"
          width="100"
          height="40"
          name="removeFilters"
          @click="removeFilters"
          :text="$t(`${I18nPrefix}DELETE_FILTER_TEXT`)"
        />
      </div>
    </div>
    <div class="mb-1">
      <div
        class="py-3 px-1 soha-title-of-filter d-flex justify-content-between"
        v-b-toggle.personal-profile
      >
        <span class="d-block">
          {{ $t(`${I18nPrefix}PERSONAL_PROFILE`) }}
        </span>
        <span class="soha-filter-arrow">
          <span class="svg-icon svg-icon-sm svg-icon-gray">
            <inline-svg src="/media/svg/soha/icons/arrow-down.svg" />
          </span>
        </span>
      </div>
      <b-collapse id="personal-profile" visible>
        <div class="soha-filter-content-panel">
          <span class="soha-title-content-filter">
            {{ $t(`${I18nPrefix}BIRTHDAY`) }}
          </span>
          <div class="row">
            <div class="col-lg-6 col-md-12 col-sm-6 col-12 m-auto">
              <div
                v-if="filteredData.birthDates[0]"
                class="soha-selected-birthday"
              >
                <span class="my-auto">
                  {{
                    $t(`${I18nPrefix}FROM_YEAR`) +
                    toPersianDigits(filteredData.birthDates[0])
                  }}
                </span>
                <span
                  class="svg-icon svg-icon-md svg-icon-secondary my-auto cursor-pointer"
                  @click="deleteBirthDate(0)"
                >
                  <inline-svg src="/media/svg/soha/icons/times.svg" />
                </span>
              </div>
              <soha-select
                class="w-100"
                v-else
                :options="years"
                :placeholder="$t(`${I18nPrefix}FROM_YEAR`)"
                v-model="filteredData.birthDates[0]"
                @onChange="setBirthDate(0)"
              />
            </div>
            <div class="col-lg-6 col-md-12 col-sm-6 col-12 m-auto">
              <div
                v-if="filteredData.birthDates[1]"
                class="soha-selected-birthday"
              >
                <span class="my-auto">
                  {{
                    $t(`${I18nPrefix}TO_YEAR`) +
                    toPersianDigits(filteredData.birthDates[1])
                  }}
                </span>
                <span
                  class="svg-icon svg-icon-md svg-icon-secondary my-auto cursor-pointer"
                  @click="deleteBirthDate(1)"
                >
                  <inline-svg src="/media/svg/soha/icons/times.svg" />
                </span>
              </div>
              <soha-select
                class="w-100"
                v-else
                :options="years"
                :placeholder="$t(`${I18nPrefix}TO_YEAR`)"
                v-model="filteredData.birthDates[1]"
                @onChange="setBirthDate(1)"
              />
            </div>
          </div>
          <soha-multi-select
            class="w-100 mb-8"
            name="genders"
            :options="filtersData.gender"
            :placeholder="$t(`${I18nPrefix}GENDER`)"
            v-model="filteredData.genders"
            @input="setQuery(filteredData.genders, 'genders')"
          />
          <soha-multi-select
            class="w-100 mb-8"
            name="military"
            :options="filtersData.militaryService"
            :placeholder="$t(`${I18nPrefix}MILITARY_SERVICE`)"
            v-model="filteredData.militaryServices"
            @input="setQuery(filteredData.militaryServices, 'militaryServices')"
          />
          <soha-multi-select
            class="w-100 mb-8"
            name="workingStatus"
            :options="filtersData.workingStatus"
            :placeholder="$t(`${I18nPrefix}EMPLOYMENT_STATUS`)"
            v-model="filteredData.workingStatuses"
            @input="setQuery(filteredData.workingStatuses, 'workingStatuses')"
          />
          <soha-multi-select
            class="w-100 mb-8"
            name="city"
            :options="cityList"
            :placeholder="$t(`${I18nPrefix}ADDRESS`)"
            v-model="filteredData.cities"
            @input="setQuery(filteredData.cities, 'cities')"
          />
          <soha-multi-select
            class="w-100 mb-8"
            name="language"
            :options="filtersData.languages"
            :placeholder="$t(`${I18nPrefix}LANGUAGE`)"
            v-model="filteredData.languages"
            @input="setQuery(filteredData.languages, 'languages')"
          />
          <soha-multi-select
            class="w-100 mb-8"
            name="tag"
            :options="filtersData.tags"
            :placeholder="$t(`${I18nPrefix}TAG`)"
            v-model="filteredData.tags"
            @input="setQuery(filteredData.tags, 'tags')"
          />
          <soha-multi-select
            class="w-100 mb-8"
            name="job"
            :options="filtersData.jobs"
            :placeholder="$t(`${I18nPrefix}JOB_OPPORTUNITY`)"
            v-model="filteredData.jobs"
            @input="setQuery(filteredData.jobs, 'jobs')"
          />
          <soha-multi-select
            class="w-100 mb-8"
            name="step"
            :options="filtersData.steps"
            :placeholder="$t(`${I18nPrefix}STEP`)"
            v-model="filteredData.steps"
            @input="setQuery(filteredData.steps, 'steps')"
          />
        </div>
      </b-collapse>
    </div>
    <div class="mb-1">
      <div
        class="soha-title-of-filter py-3 px-1 d-flex justify-content-between"
        v-b-toggle.education
      >
        <span class="d-block">
          {{ $t(`${I18nPrefix}EDUCATION`) }}
        </span>
        <span class="soha-filter-arrow">
          <span class="svg-icon svg-icon-sm svg-icon-gray">
            <inline-svg src="/media/svg/soha/icons/arrow-down.svg" />
          </span>
        </span>
      </div>
      <b-collapse
        id="education"
        :visible="
          filteredData.fields.length > 0 ||
          filteredData.majors.length > 0 ||
          filteredData.universities.length > 0 ||
          filteredData.degrees.length > 0 ||
          filteredData.educationStatuses.length > 0 ||
          filteredData.GPAs.length > 0
        "
      >
        <div class="soha-filter-content-panel">
          <!--TODO رشته تحصیلی          -->
          <div class="col p-0">
            <soha-text-field
              class="w-100"
              name="major"
              type="text"
              :placeholder="$t(`${I18nPrefix}MAJOR`)"
              v-model="selectedMajor"
              @onEnterPressed="addMajorToFilteredData"
            ></soha-text-field>
            <span
              v-if="selectedMajor"
              class="soha-filter-action"
              @click="addMajorToFilteredData"
            >
              {{ $t(`${I18nPrefix}FILTER`) }}
            </span>
          </div>
          <div class="my-2 row px-4">
            <soha-resume-selected-filter
              class="m-2"
              v-for="(major, index) in filteredData.majors"
              :key="index"
              :label="major"
              @click="removeMajorFromFilteredData(index)"
            />
          </div>
          <!--TODO گرایش تحصیلی         -->
          <div class="col p-0">
            <soha-text-field
              name="field"
              type="text"
              class="w-100"
              :placeholder="$t(`${I18nPrefix}FIELD`)"
              v-model="selectedField"
              @onEnterPressed="addFieldToFilteredData"
            ></soha-text-field>
            <span
              v-if="selectedField"
              class="soha-filter-action"
              @click="addFieldToFilteredData"
            >
              {{ $t(`${I18nPrefix}FILTER`) }}
            </span>
          </div>
          <div class="mt-2 row px-4">
            <soha-resume-selected-filter
              class="m-2"
              v-for="(field, index) in filteredData.fields"
              :key="index"
              :label="field"
              @click="removeFieldFromFilteredData(index)"
            />
          </div>

          <div class="col p-0">
            <soha-text-field
              class="w-100"
              name="university"
              type="text"
              :placeholder="$t(`${I18nPrefix}UNIVERSITY`)"
              v-model="selectedUniversity"
              @onEnterPressed="addUniversityToFilteredData"
            ></soha-text-field>
            <span
              v-if="selectedUniversity"
              class="soha-filter-action"
              @click="addUniversityToFilteredData"
            >
              {{ $t(`${I18nPrefix}FILTER`) }}
            </span>
          </div>
          <div class="my-2 row px-4">
            <soha-resume-selected-filter
              class="m-2"
              v-for="(university, index) in filteredData.universities"
              :key="index"
              :label="university"
              @click="removeUniversityFromFilteredData(index)"
            />
          </div>

          <span class="soha-title-content-filter">
            {{ $t(`${I18nPrefix}GPA`) }}
          </span>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 my-auto">
              <div v-if="filteredData.GPAs[0]" class="soha-selected-birthday">
                <span class="my-auto">
                  {{
                    $t(`${I18nPrefix}FROM`) +
                    " " +
                    toPersianDigits(filteredData.GPAs[0])
                  }}
                </span>
                <span
                  class="svg-icon svg-icon-sm svg-icon-secondary my-auto cursor-pointer"
                  @click="deleteGPA(0)"
                >
                  <inline-svg src="/media/svg/soha/icons/times.svg" />
                </span>
              </div>
              <div class="col p-0" v-else>
                <soha-text-field
                  class="w-100"
                  name="fromGPA"
                  type="text"
                  :placeholder="$t(`${I18nPrefix}FROM`)"
                  v-model="selectedFromGPA"
                  @onEnterPressed="addGPA(0)"
                ></soha-text-field>
                <span
                  v-if="selectedFromGPA"
                  class="soha-filter-action"
                  @click="addGPA(0)"
                >
                  {{ $t(`${I18nPrefix}FILTER`) }}
                </span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-6 col-12 my-auto">
              <div v-if="filteredData.GPAs[1]" class="soha-selected-birthday">
                <span class="my-auto">
                  {{
                    $t(`${I18nPrefix}TO`) +
                    " " +
                    toPersianDigits(filteredData.GPAs[1])
                  }}
                </span>
                <span
                  class="svg-icon svg-icon-sm svg-icon-secondary my-auto cursor-pointer"
                  @click="deleteGPA(1)"
                >
                  <inline-svg src="/media/svg/soha/icons/times.svg" />
                </span>
              </div>
              <div class="col p-0" v-else>
                <soha-text-field
                  class="w-100"
                  name="toGPA"
                  type="text"
                  :placeholder="$t(`${I18nPrefix}TO`)"
                  v-model="selectedToGPA"
                  @onEnterPressed="addGPA(1)"
                ></soha-text-field>
                <span
                  v-if="selectedToGPA"
                  class="soha-filter-action"
                  @click="addGPA(1)"
                >
                  {{ $t(`${I18nPrefix}FILTER`) }}
                </span>
              </div>
            </div>
          </div>
          <soha-multi-select
            class="w-100 mb-8"
            name="city"
            :options="filtersData.degrees"
            :placeholder="$t(`${I18nPrefix}GRADE`)"
            v-model="filteredData.degrees"
            @input="setQuery(filteredData.degrees, 'degrees')"
          />
          <soha-multi-select
            class="w-100 mb-8"
            name="educationStatus"
            :options="filtersData.educationStatus"
            :placeholder="$t(`${I18nPrefix}EDUCATIONAL_STATUS`)"
            v-model="filteredData.educationStatuses"
            @input="setQuery(filteredData.educationStatuses, 'educationStatuses')"
          />
        </div>
      </b-collapse>
    </div>
    <div class="mb-1">
      <div
        class="soha-title-of-filter py-3 px-1 d-flex justify-content-between"
        v-b-toggle.job-experience
      >
        <span class="d-block">
          {{ $t(`${I18nPrefix}JOB_EXPERIENCE`) }}
        </span>
        <span class="soha-filter-arrow">
          <span class="svg-icon svg-icon-sm svg-icon-gray">
            <inline-svg src="/media/svg/soha/icons/arrow-down.svg" />
          </span>
        </span>
      </div>
      <b-collapse
        id="job-experience"
        :visible="
          filteredData.companyNames.length > 0 ||
          filteredData.jobTitles.length > 0 ||
          filteredData.jobLevels.length > 0 ||
          filteredData.jobGroups.length > 0
        "
      >
        <div class="soha-filter-content-panel">
          <div class="col p-0">
            <soha-text-field
              class="w-100"
              name="organization-name"
              type="text"
              :placeholder="$t(`${I18nPrefix}ORGANIZATION_NAME`)"
              v-model="selectedCompany"
              @onEnterPressed="addCompanyToFilteredData"
            ></soha-text-field>
            <span
              v-if="selectedCompany"
              class="soha-filter-action"
              @click="addCompanyToFilteredData"
            >
              {{ $t(`${I18nPrefix}FILTER`) }}
            </span>
          </div>
          <div class="my-2 row px-4">
            <soha-resume-selected-filter
              class="m-2"
              v-for="(company, index) in filteredData.companyNames"
              :label="company"
              :key="index"
              @click="removeCompanyFromFilteredData(index)"
            />
          </div>

          <div class="col p-0">
            <soha-text-field
              class="w-100"
              name="job-title"
              type="text"
              :placeholder="$t(`${I18nPrefix}JOB_TITLE`)"
              v-model="selectedJobTitle"
              @onEnterPressed="addJobTitleToFilteredData"
            ></soha-text-field>
            <span
              v-if="selectedJobTitle"
              class="soha-filter-action"
              @click="addJobTitleToFilteredData"
            >
              {{ $t(`${I18nPrefix}FILTER`) }}
            </span>
          </div>
          <div class="my-2 row px-4">
            <soha-resume-selected-filter
              class="m-2"
              v-for="(title, index) in filteredData.jobTitles"
              :label="title"
              :key="index"
              @click="removeJobTitleFromFilteredData(index)"
            />
          </div>

          <soha-multi-select
            class="w-100 mb-8"
            name="jobLevels"
            :options="filtersData.jobLevels"
            :placeholder="$t(`${I18nPrefix}LEVEL`)"
            v-model="filteredData.jobLevels"
            @input="setQuery(filteredData.jobLevels, 'jobLevels')"
          />

          <soha-multi-select
            class="w-100 mb-8"
            name="jobGroupList"
            :options="filtersData.jobGroups"
            :placeholder="$t(`${I18nPrefix}JOB_GROUP`)"
            v-model="filteredData.jobGroups"
            @input="setQuery(filteredData.jobGroups, 'jobGroups')"
          />
        </div>
      </b-collapse>
    </div>
    <div class="mb-1">
      <div
        class="soha-title-of-filter py-3 px-1 d-flex justify-content-between"
        v-b-toggle.skill
      >
        <span class="d-block">
          {{ $t(`${I18nPrefix}SKILL`) }}
        </span>
        <span class="soha-filter-arrow">
          <span class="svg-icon svg-icon-sm svg-icon-gray">
            <inline-svg src="/media/svg/soha/icons/arrow-down.svg" />
          </span>
        </span>
      </div>
      <b-collapse id="skill" :visible="filteredData.skills.length > 0">
        <div class="soha-filter-content-panel">
          <div class="col p-0">
            <soha-text-field
              class="w-100"
              name="skill-title"
              type="text"
              :placeholder="$t(`${I18nPrefix}SKILL_TITLE`)"
              v-model="selectedSkill"
              @onEnterPressed="addSkillToFilteredData"
            ></soha-text-field>
            <span
              v-if="selectedSkill"
              class="soha-filter-action"
              @click="addSkillToFilteredData"
            >
              {{ $t(`${I18nPrefix}FILTER`) }}
            </span>
          </div>
          <div class="my-2 row px-4">
            <soha-resume-selected-filter
              class="m-2"
              v-for="(skill, index) in filteredData.skills"
              :label="skill"
              :key="index"
              @click="removeSkillFromFilteredData(index)"
            />
          </div>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import "@/assets/css/components/resume/resume-filter.css";
import ApiService from "@/core/services/api.service";
import UIMixin from "@/mixins/UIMixin";
import SohaResumeSelectedFilter from "@/view/components/resume/ResumeSelectedFilter";
import { mapGetters } from "vuex";
export default {
  name: "ResumeFilter",

  mixins: [UIMixin],

  components: { SohaResumeSelectedFilter },

  mounted() {
    this.getFilterData();
    this.parseQuery();
  },

  data() {
    return {
      I18nPrefix: "COMPONENTS.RESUME.RESUME_FILTER.",
      loading: false,
      filtersData: {},
      filterQueries: {
        page: 1,
      },
      filteredData: {
        birthDates: [],
        genders: [],
        cities: [],
        militaryServices: [],
        workingStatuses: [],
        jobs: [],
        steps: [],
        degrees: [],
        fields: [],
        majors: [],
        universities: [],
        GPAs: [],
        educationStatuses: [],
        companyNames: [],
        jobTitles: [],
        jobLevels: [],
        jobGroups: [],
        skills: [],
        languages: [],
        jobOpportunity: [],
        tags: [],
      },
      resumes: [],
      cityList: [],
      searchCityKey: null,
      searchJobGroupKey: null,
      searchLanguageKey: null,
      searchTagKey: null,
      searchJobKey: null,
      searchStepKey: null,
      selectedField: null,
      selectedMajor: null,
      selectedUniversity: null,
      selectedCompany: null,
      selectedJobTitle: null,
      selectedSkill: null,
      selectedFromGPA: null,
      selectedToGPA: null,
    };
  },

  methods: {
    getFilterData() {
      this.loading = true;
      ApiService.get("api/v2/resumes/filter-data")
        .then(({ data }) => {
          this.filtersData = JSON.parse(JSON.stringify(data));
          for (const key in this.filtersData) {
            this.filtersData[key] = this.filtersData[key].map((item) => {
              return {
                id: item.id,
                text: item.name ?? item.title,
              };
            });
          }
          this.createCityAndProvinceList(data.cities);
          this.loading = false;
        })
        .catch(() => {
          this.sendForm = false;
          this.errorMessage = "خطا در ارسال اطلاعات - مجددا تلاش کنید";
        });
    },

    filterResume() {
      this.$emit("filter", this.filterQueries);
    },

    parseQuery() {
      let url = window.location.href.split("?");
      if (url.length === 2) {
        let queries = url[1].split("&");
        for (let i = 0; i < queries.length; i++) {
          let query = decodeURI(queries[i]);
          query = query.split("=");
          let value = query[1];
          let name = query[0];
          this.filterQueries[name] = value;
          if (
            name !== "page" &&
            name !== "employerId" &&
            name !== "companyId"
          ) {
            let key = name.split("[")[0];
            this.filteredData[key].push(value);
          }
        }
      }
      this.filterResume();
    },

    removeFilters() {
      this.filteredData = {
        birthDates: [],
        genders: [],
        cities: [],
        militaryServices: [],
        workingStatuses: [],
        jobs: [],
        steps: [],
        degrees: [],
        fields: [],
        majors: [],
        universities: [],
        GPAs: [],
        educationStatuses: [],
        companyNames: [],
        jobTitles: [],
        jobLevels: [],
        jobGroups: [],
        skills: [],
        languages: [],
        jobOpportunity: [],
        tags: [],
      };
      this.$router.push({ query: { page: "1" } });
      this.$emit("onDeleteFilter");
      (this.filterQueries = {
        page: "1",
      }),
        this.filterResume();
    },

    createCityAndProvinceList(cityAndProvince) {
      let k = 0;
      for (let i = 0; i < cityAndProvince.length; i++) {
        if (cityAndProvince[i].id != 0) {
          for (let j = 0; j < cityAndProvince[i].city.length; j++) {
            this.cityList[k] = {};
            this.cityList[k]["text"] =
              cityAndProvince[i].name + " - " + cityAndProvince[i].city[j].name;
            this.cityList[k]["id"] = cityAndProvince[i].city[j].id;
            k++;
          }
        } else {
          this.cityList[k] = {};
          this.cityList[k]["text"] = cityAndProvince[i].name;
          this.cityList[k]["id"] = cityAndProvince[i].id;
          k++;
        }
      }
    },

    setQuery(data, param) {
      const queries = Object.assign({}, this.$route.query);
      for (const query in queries) {
        let name = query.split("[")[0];
        if (param === name) {
          let deleteKey = query.split("=")[0];
          delete this.filterQueries[deleteKey];
          delete queries[deleteKey];
        }
      }
      if (param !== "page") {
        for (let i = 0; i < data.length; i++) {
          let addKey = param + "[" + i + "]";
          this.filterQueries[addKey] = data[i];
          queries[addKey] = data[i];
        }
      } else {
        this.filterQueries[param] = data;
        queries[param] = data;
      }
      queries.page = "1";
      this.filterQueries.page = "1";
      this.$router.push({
        query: queries,
        params: { savedPosition: document.documentElement.scrollTop },
      });
      this.filterResume();
    },

    setBirthDate(index) {
      if (index === 0 && !this.filteredData.birthDates[1]) {
        this.filteredData.birthDates[1] = null;
      } else if (index === 1 && !this.filteredData.birthDates[0]) {
        this.filteredData.birthDates[0] = null;
      }
      setTimeout(() => {
        this.setQuery(this.filteredData.birthDates, "birthDates");
      }, 100);
    },

    deleteBirthDate(index) {
      if (index === 0 && !this.filteredData.birthDates[1]) {
        this.filteredData.birthDates.splice(
          0,
          this.filteredData.birthDates.length
        );
      } else if (index === 1 && !this.filteredData.birthDates[0]) {
        this.filteredData.birthDates.splice(
          0,
          this.filteredData.birthDates.length
        );
      } else {
        this.filteredData["birthDates"][index] = null;
        this.$forceUpdate();
      }
      this.setQuery(this.filteredData.birthDates, "birthDates");
    },

    addGPA(index) {
      if (index === 0 && !this.filteredData.GPAs[1]) {
        this.filteredData.GPAs[0] = this.selectedFromGPA;
        this.filteredData.GPAs[1] = null;
        this.selectedFromGPA = null;
      } else if (index === 1 && !this.filteredData.GPAs[0]) {
        this.filteredData.GPAs[0] = null;
        this.filteredData.GPAs[1] = this.selectedToGPA;
        this.selectedToGPA = null;
      } else if (index === 0) {
        this.filteredData.GPAs[0] = this.selectedFromGPA;
        this.selectedFromGPA = null;
      } else if (index === 1) {
        this.filteredData.GPAs[1] = this.selectedToGPA;
        this.selectedToGPA = null;
      }
      this.setQuery(this.filteredData.GPAs, "GPAs");
    },

    deleteGPA(index) {
      if (index === 0 && !this.filteredData.GPAs[1]) {
        this.filteredData.GPAs.splice(0, this.filteredData.GPAs.length);
      } else if (index === 1 && !this.filteredData.GPAs[0]) {
        this.filteredData.GPAs.splice(0, this.filteredData.GPAs.length);
      } else {
        this.filteredData["GPAs"][index] = null;
        this.$forceUpdate();
      }
      this.setQuery(this.filteredData.GPAs, "GPAs");
    },

    addFieldToFilteredData() {
      if (!this.selectedField) return;
      this.filteredData.fields.push(this.selectedField);
      this.selectedField = null;
      this.setQuery(this.filteredData.fields, "fields");
    },

    removeFieldFromFilteredData(index) {
      this.filteredData.fields.splice(index, 1);
      this.setQuery(this.filteredData.fields, "fields");
    },

    addMajorToFilteredData() {
      if (!this.selectedMajor) return;
      this.filteredData.majors.push(this.selectedMajor);
      this.selectedMajor = null;
      this.setQuery(this.filteredData.majors, "majors");
    },

    removeMajorFromFilteredData(index) {
      this.filteredData.majors.splice(index, 1);
      this.setQuery(this.filteredData.majors, "majors");
    },

    addUniversityToFilteredData() {
      if (!this.selectedUniversity) return;
      this.filteredData.universities.push(this.selectedUniversity);
      this.selectedUniversity = null;
      this.setQuery(this.filteredData.universities, "universities");
    },

    removeUniversityFromFilteredData(index) {
      this.filteredData.universities.splice(index, 1);
      this.setQuery(this.filteredData.universities, "universities");
    },

    addCompanyToFilteredData() {
      if (!this.selectedCompany) return;
      this.filteredData.companyNames.push(this.selectedCompany);
      this.selectedCompany = null;
      this.setQuery(this.filteredData.companyNames, "companyNames");
    },

    removeCompanyFromFilteredData(index) {
      this.filteredData.companyNames.splice(index, 1);
      this.setQuery(this.filteredData.companyNames, "companyNames");
    },

    addJobTitleToFilteredData() {
      if (!this.selectedJobTitle) return;
      this.filteredData.jobTitles.push(this.selectedJobTitle);
      this.selectedJobTitle = null;
      this.setQuery(this.filteredData.jobTitles, "jobTitles");
    },

    removeJobTitleFromFilteredData(index) {
      this.filteredData.jobTitles.splice(index, 1);
      this.setQuery(this.filteredData.jobTitles, "jobTitles");
    },

    addSkillToFilteredData() {
      if (!this.selectedSkill) return;
      this.filteredData.skills.push(this.selectedSkill);
      this.selectedSkill = null;
      this.setQuery(this.filteredData.skills, "skills");
    },

    removeSkillFromFilteredData(index) {
      this.filteredData.skills.splice(index, 1);
      this.setQuery(this.filteredData.skills, "skills");
    },
  },

  computed: {
    ...mapGetters(["canDo"]),

    years() {
      const year = this.$moment(new Date()).format("jYYYY");
      return Array.from({ length: 80 }, (value, index) => {
        return {
          text: this.toPersianDigits(+year - index),
          id: +year - index,
        };
      });
    },

    showDeleteFilter() {
      const queries = Object.assign({}, this.$route.query);
      for (const query in queries) {
        var show = query !== "page";
      }
      return show;
    },
  },
};
</script>
